import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'; // For making API calls
// Nijossho image path anujayi import korun - eta fallback hisebe babohar hobe
import defaultHeroBgImage from "../../assets/img/slider1.jpg"; 
import "./styles/hero.css"; // CSS file import (nishchit korun path thik ache)

const API_BASE_URL = `${process.env.REACT_APP_API_URL}banner`; // Apnar banner API-r base URL

const Hero = () => {
  const [heroData, setHeroData] = useState({
    title: "Welcome to Booze247 – Late Night Alcohol Delivery in Cardiff",
    subtitle: "Your go-to solution for fast, reliable, and convenient alcohol delivery, right when you need it – even after hours!",
    backgroundImage: defaultHeroBgImage,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
    
  
  useEffect(() => {
    const fetchFirstBanner = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(API_BASE_URL); // Fetches all banners
        if (response.data && response.data.success && response.data.data && response.data.data.length > 0) {
          // Backend already sorts by createdAt, so the first active one or the first one is good
          const banners = response.data.data;
          let bannerToShow = banners.find(banner => banner.isActive); // Prothom active banner-ta khujun
          
          if (!bannerToShow) {
            bannerToShow = banners[0]; // Jodi kono active banner na thake, tahole shudhu prothom-ta nin
          }

          if (bannerToShow) {
            setHeroData({
              // Banner theke title o description nin, noile default text babohar korun
              title: bannerToShow.title || heroData.title, 
              subtitle: bannerToShow.description || heroData.subtitle,
              // Banner er image path (/uploads/image.jpg) purno URL hobe na,
              // tai amra shudhu path-tai babohar korbo, jemon ta server serve korche
              backgroundImage: bannerToShow.image 
            });
          } else {
            // Jodi kono banner-i na paoya jay, fallback (initial state) babohar korun
            // No explicit setHeroData needed here as it's already set to default
            console.log("No banners found, using default hero data.");
          }
        } else if (response.data && response.data.data && response.data.data.length === 0) {
          console.log("No banners in the database, using default hero data.");
          // No banners, heroData will remain default
        } else {
          throw new Error(response.data.message || "Failed to fetch banners or empty data array");
        }
      } catch (err) {
        console.error("Error fetching banner for hero section:", err);
        setError(err.message || "Could not load hero banner.");
        // Error holeo default data dekhabe
      } finally {
        setIsLoading(false);
      }
    };

    fetchFirstBanner();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array means this runs once on component mount

  // Background image style conditionally set
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${process.env.REACT_APP_API_URL}uploads/${heroData.backgroundImage})`
  };
  
  // Simple loading or error state (optional, you can enhance this)
  if (isLoading) {
    return (
      <div>
        <section>
          <div 
            className="swiper-slide slide-hero hero-container-section" 
            style={{ 
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${defaultHeroBgImage})`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                minHeight: '60vh' // Adjust as needed
            }}
          >
            <div className="slider_text text-center">
              <div className="spinner-border text-light" role="status" style={{width: '3rem', height: '3rem'}}>
                <span className="visually-hidden">Loading Hero...</span>
              </div>
              <p className="mt-2">Loading awesome content...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // Error state can also show the default hero or a specific error message
  // For now, if there's an error, it will use the default heroData set initially.
  // You could add: if (error) return <div>Error loading banner: {error}</div>;

  return (
    // User er original outer div and section structure rakha holo
    <div >
      <section>
        <div
          // Swiper specific class gulo rakha hoyeche jodi Swiper use koren
          className="swiper-slide slide-hero hero-container-section" 
          style={heroStyle} // Dynamic background image and overlay
          // data-swiper-parallax attributes Swiper active thakle kaj korbe
        >
          <div className="slider_text">
            {/* Dynamic title and subtitle */}
            <div className="title hero-title" data-swiper-parallax="-300">
              {heroData.title}
            </div>
            <div className="subtitle" data-swiper-parallax="-200">
              {heroData.subtitle}
            </div>
            <div className="shop_btn">
              <Link to="/shop" className="Shop_Now_hero">
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
